import { primitives } from '@monorepo/tools/src/lib/types/primitives';

export const areSetsEqual = (a: Set<primitives>, b: Set<primitives>) => a.size === b.size && Array.from(a).every(value => b.has(value));
export const setToString = (list: Set<string>, joinChar = '\n'): string => Array.from(list).join(joinChar);
export const setToArray = (model: Set<string>): string[] => {
	return Array.from(model).map(value => value);
};
